export const ENVIRONMENT = process.env.NODE_ENV;

export const URL = process.env.REACT_APP_URL;

export const URL_CDN = process.env.REACT_APP_URL_CDN;

export const URL_SYSTEM = process.env.REACT_APP_URL_SYSTEM;
export const URL_BILLING = process.env.REACT_APP_URL_BILLING;
export const URL_AUTH = process.env.REACT_APP_URL_AUTH;
export const URL_HUB = process.env.REACT_APP_URL_HUB;
export const URL_UPLOAD = process.env.REACT_APP_URL_UPLOAD;
export const URL_GAME = process.env.REACT_APP_URL_GAME;
export const URL_ITEM = process.env.REACT_APP_URL_ITEM;

export const OAUTH2_CLIENT_ID = process.env.REACT_APP_OAUTH2_CLIENT_ID;
export const OAUTH2_CLIENT_SECRET = process.env.REACT_APP_OAUTH2_CLIENT_SECRET;

export const SETTLEBANK_SCRIPT = process.env.REACT_APP_SETTLEBANK_SCRIPT;
export const SETTLEBANK_BANK_SCRIPT = process.env.REACT_APP_SETTLEBANK_BANK_SCRIPT;
export const PAYAPAL_CLIENTID = process.env.REACT_APP_PAYAPAL_CLIENTID;

export const TOURNAMENT_GRADE_DATA = [
  [
    { gradeType: 6, stepType: 3, isParticipation: true, handicap: 0 },
    { gradeType: 6, stepType: 2, isParticipation: true, handicap: 0 },
    { gradeType: 6, stepType: 1, isParticipation: true, handicap: 0 },
  ],
  [
    { gradeType: 5, stepType: 3, isParticipation: true, handicap: 0 },
    { gradeType: 5, stepType: 2, isParticipation: true, handicap: 0 },
    { gradeType: 5, stepType: 1, isParticipation: true, handicap: 0 },
  ],
  [
    { gradeType: 4, stepType: 3, isParticipation: true, handicap: 0 },
    { gradeType: 4, stepType: 2, isParticipation: true, handicap: 0 },
    { gradeType: 4, stepType: 1, isParticipation: true, handicap: 0 },
  ],
  [
    { gradeType: 3, stepType: 3, isParticipation: true, handicap: 0 },
    { gradeType: 3, stepType: 2, isParticipation: true, handicap: 0 },
    { gradeType: 3, stepType: 1, isParticipation: true, handicap: 0 },
  ],
  [
    { gradeType: 2, stepType: 3, isParticipation: true, handicap: 0 },
    { gradeType: 2, stepType: 2, isParticipation: true, handicap: 0 },
    { gradeType: 2, stepType: 1, isParticipation: true, handicap: 0 },
  ],
];
